<style scoped>
.tag-item {
  margin: 4px;
  vertical-align: middle;
  display: inline;
}
.zoom {
  zoom: 1.2;
  box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.75);
}

</style>

<template>
  <div v-if="flagFetchedReaction">
    <v-touch 
      @swipe="onSwipeVote(item._id)"
      @tap="onClickVote(item._id)"
      v-for="(item, index) in tags"
      class="tag-item"
      v-tooltip="stringTooltip(item)"
      >
      <mu-chip
      :style="styleTag(item)"
      :class="modelTagIdInRangeMode === item._id ? 'zoom' : ''">
         {{item.name}} <span v-if="modelTagIdInRangeMode === item._id">{{ ': ' + stringTime(timestampStart) + ' ~ ' + (timestampEnd !== -1 ? (stringTime(timestampEnd)) : '?') }}</span>
      </mu-chip>
    </v-touch>
  </div>

</template>

<script>

// Library
import axios from "axios";

// Utils
import timeFormatter from '@/utils/timeFormatter.js'

export default {
  name: 'TagPanel',
  props: {
    mediaId: {
      type: String,
      required: true
    },
    media: {
      type: Object,
      required: true
    },
    currentTime: {
      type: Number,
      required: true
    },
    tag: {
      type: Object,
      default() {
        return {
          action: '',
          tagId: ''
        }
      }
    },
  },
  data() {
    return {
      // Object
      tags: [],
      reaction: {}, // Reaction count object
      modelComment: "",
      modelTagId: "",
      form: {},
      modelTagIdInRangeMode: "",
      timestampStart: 0,
      timestampEnd: -1,

      // Flag
      flagFetchedTag: false, // Boolean variable for status of tag fetched
      flagFetchedReaction: false, // Boolean variable for status of tag fetched
    }
  },
  computed: {
    // Store
    triggerRefresh() {
      return this.$store.getters.triggerRefresh;
    },
    isReactionEmpty() {
      var result = true;
      Object.keys(this.reaction).forEach(key => {
        if(this.reaction[key].count > 0) {
          result = false;
        }
      });
      return result;
    },
  },
  mounted() {
    this.fetchTags();
    this.fetchReaction();
  },
  watch: {
    mediaId() {
      this.fetchTags();
      this.fetchReaction();
    },
    triggerRefresh() {
      this.fetchTags();
      this.fetchReaction();
    },
    tag: {
      handler(newValue) {
        if(newValue.action === 'clear') {
          this.modelTagIdInRangeMode = '';
        }
      },
      deep: true
    },
  },
  methods: {
    // Fetch
    fetchTags() {
      axios.get(this.$store.getters.urlApi + "tag/media/" + this.mediaId, {
        headers: {
          token: this.$store.state.auth.token
        }
      }).then(response => {
        if(response.data.data.tags)
          this.tags = response.data.data.tags;
        this.flagFetchedTag = true;
      });
    },
    fetchReaction() {
      axios.get(this.$store.getters.urlApi + "reaction/media/" + this.mediaId + '/tag', {
        headers: {
          token: this.$store.state.auth.token
        }
      }).then(response => {
        this.reaction = response.data.data.reaction
        this.flagFetchedReaction = true;
      });
    },
    
    onSwipeVote(tag_id) {
      // Determine keyword tagging is in comment mode
      if(this.media.hasOwnProperty('comment_mode') && this.media.comment_mode) {
        if(this.modelTagIdInRangeMode === tag_id) { // If previously pressed that tag
          this.modelTagIdInRangeMode = ''; // Clear the tag id as the process is ended
          this.$emit('onClickTag', {  // Send event of end action
            action: 'end',
            tagId: tag_id
          });
        } else { // If no previously pressed tag or previously pressed tag not the same
          this.modelTagIdInRangeMode = tag_id; // Save the tag id down
          this.timestampStart = this.currentTime;
          this.$emit('onClickTag', { // Send event of start action
            action: 'start',
            tagId: tag_id
          });
        }
      } else {
        if(this.modelTagIdInRangeMode === tag_id) { // If previously pressed that tag
          this.modelTagIdInRangeMode = ''; // Clear the tag id as the process is ended
          this.timestampEnd = this.currentTime;
          this.onActionVote(tag_id, true);
        } else { // If no previously pressed tag or previously pressed tag not the same
          this.modelTagIdInRangeMode = tag_id; // Save the tag id down
          this.timestampStart = this.currentTime;
          this.timestampEnd = -1;
        }
      }
    },

    // Event
    onClickVote(tag_id) {
      if(this.modelTagIdInRangeMode === tag_id) { // If previously pressed that tag
        if(this.media.hasOwnProperty('comment_mode') && this.media.comment_mode) {
          this.modelTagIdInRangeMode = ''; // Clear the tag id as the process is ended
          this.timestampEnd = this.currentTime;
          this.$emit('onClickTag', {  // Send event of end action
            action: 'end',
            tagId: tag_id
          });
        } else {
          this.modelTagIdInRangeMode = ''; // Clear the tag id as the process is ended
          this.timestampEnd = this.currentTime;
          this.onActionVote(tag_id, true);
        }
      }
      // Determine keyword tagging is in comment mode
      else if(this.media.hasOwnProperty('comment_mode') && this.media.comment_mode) {
        this.timestampEnd = -1;
        this.$emit('onClickTag', { // Send event of pressed action for non-range mode keyword tagging
          action: 'click',
          tagId: tag_id
        });
      } else {
        this.timestampStart = this.currentTime;
        this.onActionVote(tag_id); // Directly insert reaction
      }
    },
    onActionVote(tag_id, range_mode = false) {
      var data = {
        'timestamp': Math.floor(this.timestampStart)
      };
      if(range_mode) {
        data['timestampEnd'] = Math.floor(this.timestampEnd);
      }
      axios.post(this.$store.getters.urlApi + "comment/media/" + this.mediaId + '/tag/' + tag_id, data, {
        headers: {
          token: this.$store.state.auth.token,
          'content-type': 'application/json'
        },
      }).then(() => {
        this.timestampStart = 0;
        this.timestampEnd = -1;
        this.fetchReaction();
        this.$store.commit('triggerRefresh');
        this.$toast.success(this.$t('toast.create'));
      });
    },

    // Style
    styleTag(tag) {
      return {
        color: this.stringColor(tag),
        backgroundColor: this.stringBgColor(tag),
      };
    },
    stringColor(tag) {
      if (typeof tag.color != 'undefined')
        return "rgba(" + tag.color.r + ", " + tag.color.g + ", " + tag.color.b + ", " + tag.color.a + ")";
      else
        return "rgba(255,255,255,1)";
    },
    stringBgColor(tag) {
      if (typeof tag.backgroundColor != 'undefined')
        return "rgba(" + tag.backgroundColor.r + ", " + tag.backgroundColor.g + ", " + tag.backgroundColor.b + ", " + tag.backgroundColor.a + ")";
      else
        return "rgba(0,0,0,0.5)";
    },

    // String
    stringTooltip(item) {
      if(this.reaction.hasOwnProperty(item['_id'])) {
        return this.reaction[item['_id']]['count'] + this.$t('tag.click') + this.reaction[item['_id']]['user'] + this.$t('stat.user_engage');
      } else {
        return '0' + this.$t('tag.click') + '0' + this.$t('stat.user_engage');
      }
    },
    stringTime(time) {
      return timeFormatter(time);
    },
  },
}
</script>
